import React, { useState, useEffect } from "react";
import Header from "../components/Header.jsx";
import Sidebar from "../components/Sidebar";
import IdleTimer from "./IdleTimerComponent";
import { Spinner } from "react-bootstrap";
import {
  fetchStateList,
  fetchAllocatedSalesOfficeList,
  fetchClassificationsList,
  fetchUltmarcFacilitySuperTypeList,
  fetchMedicalSpecialitySuperTypeList,
  fetchBUList,
  fetchDeleteReasonList,
  fetchUserRole,
  changeLanguage,
  languageChange,
} from "./OrganizationCustomer/actions";
import {
  fetchPersonClassificationsList,
  fetchUniversityList,
  fetchGenderList,
  fetchPersonMedicalSpecialitySuperTypeList,
} from "./PersonCustomer/actions";
import {
  fetchDepartmentList,
  fetchRoleList,
  fetchManagementBodyList,
  fetchSpecialityList,
} from "./NewCustomerRequest/actions";
import {
  fetchProductsList,
  fetchMarketAuthorizationList,
  fetchFormList,
  fetchFormulationList,
  fetchPackagingList,
  fetchHundredBedsList,
  fetchTwoHundredBedsList,
  fetchEvaluationTargetClassificationList,
  fetchSalesPrefectureList,
  fetchWholesalerGroupList,
  fetchTargetPeriod,
  fetchWholesalerLevelList,
} from "./SalesReports/actions";
import { fetchTerritoryBUList } from "./TerritoryDefinition/actions";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LOGIN_URL } from "../config/config";

function Home(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [trans, i18n] = useTranslation("language");
  const [token, setToken] = useState("");
  const [userRole, setUserRole] = useState("");
  const [expiryTime, setExpiryTime] = useState("");
  const [loading, setLoading] = useState(
    sessionStorage.getItem("token") === "" ? true : false
  );
  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    // setUserRole("Admin");
    // sessionStorage.setItem("Username", "John Doe")
    // sessionStorage.setItem("User role", "Admin");
    // sessionStorage.setItem("WWID", "81095017")
    // sessionStorage.setItem("Organization name", "IBD")
    // sessionStorage.setItem("Kanji name", "John")
    let redirect = sessionStorage.getItem("return_url");
    if (redirect === "" || redirect === null) {
      sessionStorage.setItem("return_url", "");
    } else {
      sessionStorage.setItem("return_url", redirect);
    }

    if (window.screen.width <= 767) {
      document.body.classList.add("sidebar-collapse");
    }

    window.scrollTo(0, 0);
    let loginToken;
    let path;
    let pathname = window.location.pathname;
    let url = window.location.href;
    path = unescape(pathname).split("/?")[1];
    loginToken = unescape(url).split("/?token=")[1]?.replace(/#.*$/, '');
    let wwid = sessionStorage.getItem("WWID");
    if (sessionStorage.getItem("token") === null) {
      sessionStorage.setItem("token", "");
    }
    if (loginToken) {
      sessionStorage.setItem("token", loginToken);
      sessionStorage.setItem("User role", "");
      const queryParams = new URLSearchParams(location.search);
      if (queryParams.has("token")) {
        queryParams.delete("token");
        navigate({ search: queryParams.toString() }, { replace: true });
      }
      getUserRole(loginToken);
    }
    const token = sessionStorage.getItem("token");
    setToken(token);
    if (token === "" || token === undefined || token === null) {
      window.location.assign(LOGIN_URL);
    } else {
      !sessionStorage.getItem("Department") && getDepartmentList();
      !sessionStorage.getItem("Role") && getRoleList();
      !sessionStorage.getItem("Management body") && getManagementBody();
      !sessionStorage.getItem("Speciality") && getSpeciality();
      !sessionStorage.getItem("Planned delete reason") && getDeleteReasonList();
      !sessionStorage.getItem("Product") && getProductList();
      !sessionStorage.getItem("Market Auth List") &&
        getMarketAuthorizationList();
      !sessionStorage.getItem("Form") && getFormList();
      !sessionStorage.getItem("Formulation") && getFormulationList();
      !sessionStorage.getItem("Pack") && getPackList();
      !sessionStorage.getItem("Hundred beds sales") && getHundredBedsList();
      !sessionStorage.getItem("Two hundred beds sales") &&
        getTwoHundredBedsList();
      !sessionStorage.getItem("Evaluation target classification") &&
        getEvaluationTargetClassificationList();
      !sessionStorage.getItem("Sales prefecture") && getSalesPrefectureList();
      !sessionStorage.getItem("Wholesaler group list") &&
        getWholesalerGroupList();
      !sessionStorage.getItem("Wholesaler Level One") &&
        getWholesaleLevelOneList();
      !sessionStorage.getItem("Wholesaler Level Two") &&
        getWholesaleLevelTwoList();
      !sessionStorage.getItem("Wholesaler Level Three") &&
        getWholesaleLevelThreeList();
      !sessionStorage.getItem("Wholesaler Level Four") &&
        getWholesaleLevelFourList();
      !sessionStorage.getItem("Wholesaler Level Five") &&
        getWholesaleLevelFiveList();
      !sessionStorage.getItem("Wholesaler Level Six") &&
        getWholesaleLevelSixList();
      !sessionStorage.getItem("University list") && getUniversityList();
      !sessionStorage.getItem("Gender list") && getGenderList();
      !sessionStorage.getItem("Person medical speciality super type list") &&
        getPersonMedicalSpecialitySuperType();
      if (
        !sessionStorage.getItem("Person hundred beds list") ||
        !sessionStorage.getItem("Person facility class list") ||
        !sessionStorage.getItem("Person ultmarc record list") ||
        !sessionStorage.getItem("Person ultmarc hospital list") ||
        !sessionStorage.getItem("Person customer type") ||
        !sessionStorage.getItem("Person facility function")
      ) {
        getPersonClassification();
      }
    }

    const userRole = sessionStorage.getItem("User role");
    if (userRole) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, []);

  /*** 
  @purpose : Get user role
  @Parameter : {}
  **/
  const getUserRole = async (token) => {
    await fetchUserRole(token).then((response) => {
      if (response.success === true) {
        setUserDetails(response.data);
        setUserRole(response.data.pimcore_role);
        setExpiryTime(response.data.expiry_time);
        var date = new Date(response.data.expiry_time * 1000);
        sessionStorage.setItem("User role", response.data.pimcore_role);
        sessionStorage.setItem("Username", response.data.name);
        sessionStorage.setItem("salesOfficeID", response.data.salesOfficeID);
        sessionStorage.setItem("buID", response.data.buID);
        sessionStorage.setItem("divisionID", response.data.divisionID);
        sessionStorage.setItem("branchId", response.data.branchId);
        sessionStorage.setItem(
          "Organization name",
          response.data.organization_name_jp
        );
        sessionStorage.setItem("WWID", response.data.wwid);
        sessionStorage.setItem(
          "Kanji name",
          response.data.employee_name_japanese
        );
        sessionStorage.setItem("Language", response.data.preferred_language);
        if (response.data.preferred_language === "") {
          sessionStorage.setItem("Language", "jp");
          let body = {
            wwid: response.data.wwid,
            language: "jp",
          };
          languageChange(body).then((response) => { });
        } else {
          const data = {
            language: response.data.preferred_language,
          };
          changeLanguage(data);
          i18n.changeLanguage(response.data.preferred_language);
        }
        // !sessionStorage.getItem("Territory BU") && getTerritoryBUList(response.data.wwid);
        setLoading(false);
      } else {
        setLoading(true);
      }
    });
  };

  /*** 
  @purpose : Get person classification list
  @Parameter : {}
  **/
  const getPersonClassification = async () => {
    await fetchPersonClassificationsList().then((res) => {
      let bedList = [];
      let facClassList = [];
      let ultRecordList = [];
      let ultHospitalList = [];
      let custTypeList = [];
      let facFunctionList = [];
      if (res.hundredBeds) {
        for (let index = 0; index < res.hundredBeds.length; index++) {
          const item = res.hundredBeds[index];
          bedList.push({
            value: item.hundredBedsType,
            label: item.hundredBedsTypeName,
          });
        }
        sessionStorage.setItem(
          "Person hundred beds list",
          JSON.stringify(bedList)
        );
      }
      if (res.facilityClass) {
        for (let index = 0; index < res.facilityClass.length; index++) {
          const item = res.facilityClass[index];
          facClassList.push({
            value: item.facilityClassType,
            label: item.facilityClassTypeName,
          });
        }
        sessionStorage.setItem(
          "Person facility class list",
          JSON.stringify(facClassList)
        );
      }
      if (res.ultmarcRecord) {
        for (let index = 0; index < res.ultmarcRecord.length; index++) {
          const item = res.ultmarcRecord[index];
          ultRecordList.push({
            value: item.ultmarcRecordID,
            label: item.ultmarcRecordIDName,
          });
        }
        sessionStorage.setItem(
          "Person ultmarc record list",
          JSON.stringify(ultRecordList)
        );
      }
      if (res.ultmarcHospital) {
        for (let index = 0; index < res.ultmarcHospital.length; index++) {
          const item = res.ultmarcHospital[index];
          ultHospitalList.push({
            value: item.ultmarcHospitalType,
            label: item.ultmarcHospitalTypeName,
          });
        }
        sessionStorage.setItem(
          "Person ultmarc hospital list",
          JSON.stringify(ultRecordList)
        );
      }
      if (res.custType) {
        for (let index = 0; index < res.custType.length; index++) {
          const item = res.custType[index];
          custTypeList.push({
            value: item.custTypeID,
            label: item.customerTypeNameLocal,
          });
        }
        sessionStorage.setItem(
          "Person customer type",
          JSON.stringify(custTypeList)
        );
      }
      if (res.facilityFunction) {
        for (let index = 0; index < res.facilityFunction.length; index++) {
          const item = res.facilityFunction[index];
          facFunctionList.push({
            value: item.facilityFunctionType,
            label: item.facilityFunctionTypeName,
          });
        }
        sessionStorage.setItem(
          "Person facility function",
          JSON.stringify(facFunctionList)
        );
      }
    });
  };

  /*** 
  @purpose : Get department list
  @Parameter : {}
  **/
  const getDepartmentList = async () => {
    await fetchDepartmentList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.affiliatedDepartmentID,
          label: item.affiliatedDepartmentNameLocal,
        });
      }
      sessionStorage.setItem("Department", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get role list
  @Parameter : {}
  **/
  const getRoleList = async () => {
    await fetchRoleList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({ value: item.jobTitleID, label: item.jobTitleNameLocal });
      }
      sessionStorage.setItem("Role", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get management body list
  @Parameter : {}
  **/
  const getManagementBody = async () => {
    await fetchManagementBodyList().then((res) => {
      let data = [];
      let obj = {};
      for (var property in res) {
        var n = property;
        obj = { label: n, options: res[n] };
        data.push(obj);
      }
      let newList = [];
      for (let i = 0; i < data.length; i++) {
        let list = [];
        for (let index = 0; index < data[i].options.length; index++) {
          const item = data[i].options[index];
          list.push({
            value: item.managementBodyTypeID,
            label: item.management_body_type_name,
          });
        }
        newList.push({ label: data[i].label, options: list });
      }
      sessionStorage.setItem("Management body", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get speciality list
  @Parameter : {}
  **/
  const getSpeciality = async () => {
    await fetchSpecialityList().then((res) => {
      let data = [];
      let obj = {};
      for (var property in res) {
        var n = property;
        obj = { label: n, options: res[n] };
        data.push(obj);
      }
      let newList = [];
      for (let i = 0; i < data.length; i++) {
        let list = [];
        for (let index = 0; index < data[i].options.length; index++) {
          const item = data[i].options[index];
          list.push({
            value: item.medicalSpecialityID,
            label: item.medical_speciality_name_local,
          });
        }
        newList.push({ label: data[i].label, options: list });
      }
      sessionStorage.setItem("Speciality", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get delete reason list
  @Parameter : {}
  **/
  const getDeleteReasonList = async () => {
    await fetchDeleteReasonList().then((res) => {
      let list = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        list.push({
          value: item.plannedDeleteType,
          label: item.plannedDeleteName,
        });
      }
      sessionStorage.setItem("Planned delete reason", JSON.stringify(list));
    });
  };

  /*** 
  @purpose : Get university list
  @Parameter : {}
  **/
  const getUniversityList = async () => {
    await fetchUniversityList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({ value: item.uniID, label: item.uniName });
      }
      sessionStorage.setItem("University list", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get gender list
  @Parameter : {}
  **/
  const getGenderList = async () => {
    await fetchGenderList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({ value: item.genderType, label: item.genderTypeName });
      }
      sessionStorage.setItem("Gender list", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get medical speciality super type list
  @Parameter : {}
  **/
  const getPersonMedicalSpecialitySuperType = async () => {
    await fetchPersonMedicalSpecialitySuperTypeList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.medicalSpecialityOneID,
          label: item.medicalSpecialityNameLocalOne,
        });
      }
      sessionStorage.setItem(
        "Person medical speciality super type list",
        JSON.stringify(newList)
      );
    });
  };

  /*** 
  @purpose : Get product list
  @Parameter : {}
  **/
  const getProductList = async () => {
    await fetchProductsList().then((res) => {
      let newList = [];
      if (res && res.length > 0) {
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          newList.push({
            value: item.prdctlvl_cd,
            label: item.prdctlvl_sym,
          });
        }
        sessionStorage.setItem("Product", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get market auth list
  @Parameter : {}
  **/
  const getMarketAuthorizationList = async () => {
    let body = {
      prdctlvl_cd: "ALL",
    };
    await fetchMarketAuthorizationList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        sessionStorage.setItem("Market Auth List", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get form list
  @Parameter : {}
  **/
  const getFormList = async () => {
    let body = {
      aprlvl_cd: "ALL",
      // "market_authorization": "ALL"
    };
    await fetchFormList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        sessionStorage.setItem("Form", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get formulation list
  @Parameter : {}
  **/
  const getFormulationList = async () => {
    let body = {
      frmlvl_cd: "ALL",
      // "market_authorization": "ALL",
      // "form_codes": "ALL"
    };
    await fetchFormulationList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        sessionStorage.setItem("Formulation", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get pack list
  @Parameter : {}
  **/
  const getPackList = async () => {
    let body = {
      stdlvl_cd: "ALL",
    };
    await fetchPackagingList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        sessionStorage.setItem("Pack", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get hundred beds sales list
  @Parameter : {}
  **/
  const getHundredBedsList = async () => {
    await fetchHundredBedsList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      sessionStorage.setItem("Hundred beds sales", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get two hundred beds sales list
  @Parameter : {}
  **/
  const getTwoHundredBedsList = async () => {
    await fetchTwoHundredBedsList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      sessionStorage.setItem("Two hundred beds sales", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get evaluation target classification
  @Parameter : {}
  **/
  const getEvaluationTargetClassificationList = async () => {
    await fetchEvaluationTargetClassificationList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      sessionStorage.setItem(
        "Evaluation target classification",
        JSON.stringify(newList)
      );
    });
  };

  /*** 
  @purpose : Get BU list
  @Parameter : {}
  **/
  const getTerritoryBUList = async (wwid) => {
    await fetchTerritoryBUList(wwid).then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({ value: item.buID, label: item.orgName });
      }
      sessionStorage.setItem("Territory BU", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get two hundred beds sales list
  @Parameter : {}
  **/
  const getSalesPrefectureList = async () => {
    await fetchSalesPrefectureList().then((res) => {
      const newList = Array.isArray(res)
        ? res.map((item) => ({
          value: item.state_province_code,
          label: item.state_province_name_local,
        }))
        : [];
      sessionStorage.setItem("Sales prefecture", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getWholesalerGroupList = async () => {
    await fetchWholesalerGroupList().then((response) => {
      if (response.data.success == true && response.data.data) {
        let newList = [];
        for (let index = 0; index < response.data.data.length; index++) {
          const item = response.data.data[index];
          newList.push({
            value: item.wholesaler_organization_code_jp,
            label: item.wholesaler_organization_name,
          });
        }
        sessionStorage.setItem(
          "Wholesaler group list",
          JSON.stringify(newList)
        );
      }
    });
  };

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getWholesaleLevelOneList = async () => {
    let body = {
      org_level: 1,
    };
    await fetchWholesalerLevelList(body).then((response) => {
      if (response && response.data && response.data.length > 0) {
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_grp_cd,
            label: item.whsl_grp_nm,
          });
        }
        sessionStorage.setItem("Wholesaler Level One", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getWholesaleLevelTwoList = async () => {
    let body = {
      // "org_level":2,
      whsl_grp_cd: "ALL",
    };
    await fetchWholesalerLevelList(body).then((response) => {
      if (response && response.data && response.data.length > 0) {
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_crp_cd,
            label: item.whsl_crp_nm,
          });
        }
        sessionStorage.setItem("Wholesaler Level Two", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getWholesaleLevelThreeList = async () => {
    let body = {
      // "org_level":3,
      whsl_crp_cd: "ALL",
    };
    await fetchWholesalerLevelList(body).then((response) => {
      if (response && response.data && response.data.length > 0) {
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_unf_dpt_cd,
            label: item.whsl_unf_dpt_nm,
          });
        }
        sessionStorage.setItem(
          "Wholesaler Level Three",
          JSON.stringify(newList)
        );
      }
    });
  };

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getWholesaleLevelFourList = async () => {
    let body = {
      // "org_level":4,
      whsl_unf_dpt_cd: "ALL",
    };
    await fetchWholesalerLevelList(body).then((response) => {
      if (response && response.data && response.data.length > 0) {
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_dpt_cd,
            label: item.whsl_dpt_nm,
          });
        }
        sessionStorage.setItem(
          "Wholesaler Level Four",
          JSON.stringify(newList)
        );
      }
    });
  };

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getWholesaleLevelFiveList = async () => {
    let body = {
      // "org_level":5,
      whsl_dpt_cd: "ALL",
    };
    await fetchWholesalerLevelList(body).then((response) => {
      if (response && response.data && response.data.length > 0) {
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_bra_cd,
            label: item.whsl_bra_nm,
          });
        }
        sessionStorage.setItem(
          "Wholesaler Level Five",
          JSON.stringify(newList)
        );
      }
    });
  };

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getWholesaleLevelSixList = async () => {
    let body = {
      // "org_level":6,
      whsl_bra_cd: "ALL",
    };
    await fetchWholesalerLevelList(body).then((response) => {
      if (response && response.data && response.data.length > 0) {
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_sct_cd,
            label: item.whsl_sct_nm,
          });
        }
        sessionStorage.setItem("Wholesaler Level Six", JSON.stringify(newList));
      }
    });
  };

  return (
    <>
      <IdleTimer></IdleTimer>
      <div className="container-scroller" id="home">
        {token && loading === false ? (
          <>
            <Header name={userDetails.name} />
            <Sidebar role={userRole} />
            {sessionStorage.getItem("return_url") !== "" && (
              <Navigate to={sessionStorage.getItem("return_url")} />
            )}
            {(sessionStorage.getItem("return_url") === "" ||
              sessionStorage.getItem("return_url") === null) && (
                <div className="page-body-wrapper">{props.children}</div>
              )}
          </>
        ) : (
          <div className="redirect-message">
            <div>
              <Spinner animation="border" />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Home;
